export default "__VITE_ASSET__BdjKJq5u__"